module.exports = "<p class=\"no-data\">{{ t('usageGraph.noDataAvailable') }}</p>\n<canvas class=\"usage-canvas\" style=\"display: none;\" width=\"813\" height=\"300\"></canvas>\n";
